import React from 'react';
import { Component } from 'react';

export class Snow extends Component {
render(){
  return (
    <div className="Icon">
     <svg version="1.1" id="snow" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24">
<rect x="0" y="0" fill="none" width="24" height="24"/>
<g>
	<path fillRule="evenodd" clipRule="evenodd" fill="#FFFFFF" d="M5.25,15.5c-1.5166,0-2.75-1.2334-2.75-2.75
		c0-1.126,0.6777-2.1265,1.7266-2.5483l0.3506-0.1406l-0.04-0.3755C4.5137,9.4609,4.5,9.2324,4.5,9c0-3.584,2.916-6.5,6.5-6.5
		c2.9912,0,5.583,2.0288,6.3018,4.9331l0.0908,0.3677l0.3789,0.0117C19.8623,7.8789,21.5,9.5645,21.5,11.6499
		c0,2.123-1.7275,3.8501-3.8506,3.8501H5.25z"/>
	<path fill="#1D1D33" d="M10.9999,2.9999c2.7609,0,5.1527,1.8724,5.8163,4.5533l0.182,0.7352l0.757,0.024
		c1.8195,0.0577,3.2447,1.5237,3.2447,3.3376c0,1.8472-1.5028,3.35-3.35,3.35h-12.4c-1.2407,0-2.25-1.0094-2.25-2.2501
		c0-0.921,0.5546-1.7391,1.413-2.0842l0.6992-0.2811L5.0346,9.6352C5.0113,9.4094,4.9999,9.2016,4.9999,9
		C4.9999,5.6916,7.6915,2.9999,10.9999,2.9999 M10.9999,1.9999c-3.866,0-7,3.1331-7,7.0001c0,0.2501,0.015,0.4961,0.04,0.738
		c-1.194,0.48-2.04,1.6451-2.04,3.012c0,1.794,1.455,3.2501,3.25,3.2501h12.4c2.403,0,4.35-1.9481,4.35-4.35
		c0-2.3561-1.875-4.263-4.213-4.3372C17.0319,4.263,14.2839,1.9999,10.9999,1.9999L10.9999,1.9999z"/>
</g>
<path fill="#0072F5" d="M6.3198,19.6601l-0.8167,0.4714l0.8167,0.4714c0.2393,0.1382,0.3213,0.4438,0.1826,0.6831
	c-0.0918,0.1602-0.2607,0.25-0.4326,0.25c-0.085,0-0.1709-0.0215-0.25-0.0669l-0.8164-0.4713v0.943c0,0.2764-0.2236,0.5-0.5,0.5
	s-0.5-0.2236-0.5-0.5v-0.9435L3.186,21.4692c-0.0791,0.0454-0.165,0.0669-0.25,0.0669c-0.1719,0-0.3408-0.0898-0.4326-0.25
	c-0.1387-0.2393-0.0566-0.5449,0.1826-0.6831l0.8167-0.4714L2.686,19.6601c-0.2393-0.1382-0.3213-0.4438-0.1826-0.6831
	c0.1377-0.2388,0.4443-0.3203,0.6826-0.1831l0.8174,0.4719v-0.9435c0-0.2764,0.2236-0.5,0.5-0.5s0.5,0.2236,0.5,0.5v0.943
	l0.8164-0.4713c0.2383-0.1387,0.5449-0.0566,0.6826,0.1831C6.6411,19.2163,6.5591,19.5219,6.3198,19.6601z M21.314,20.603
	l-0.8167-0.4714l0.8167-0.4714c0.2393-0.1382,0.3213-0.4438,0.1826-0.6831c-0.1377-0.2397-0.4453-0.3218-0.6826-0.1831
	l-0.8174,0.4719v-0.9435c0-0.2764-0.2236-0.5-0.5-0.5s-0.5,0.2236-0.5,0.5v0.943l-0.8164-0.4713
	c-0.2383-0.1372-0.5449-0.0557-0.6826,0.1831c-0.1387,0.2393-0.0566,0.5449,0.1826,0.6831l0.8167,0.4714l-0.8167,0.4714
	c-0.2393,0.1382-0.3213,0.4438-0.1826,0.6831c0.0918,0.1602,0.2607,0.25,0.4326,0.25c0.085,0,0.1709-0.0215,0.25-0.0669
	l0.8164-0.4713v0.943c0,0.2764,0.2236,0.5,0.5,0.5s0.5-0.2236,0.5-0.5v-0.9435l0.8174,0.4719
	c0.0791,0.0454,0.165,0.0669,0.25,0.0669c0.1719,0,0.3408-0.0898,0.4326-0.25C21.6352,21.0468,21.5532,20.7412,21.314,20.603z
	 M13.9995,18.977c-0.1377-0.2397-0.4443-0.3218-0.6826-0.1831l-0.8164,0.4713v-0.943c0-0.2764-0.2236-0.5-0.5-0.5
	s-0.5,0.2236-0.5,0.5v0.9435l-0.8174-0.4719c-0.2383-0.1372-0.5449-0.0557-0.6826,0.1831
	c-0.1387,0.2393-0.0566,0.5449,0.1826,0.6831l0.8167,0.4714l-0.8167,0.4714c-0.2393,0.1382-0.3213,0.4438-0.1826,0.6831
	c0.0918,0.1602,0.2607,0.25,0.4326,0.25c0.085,0,0.1709-0.0215,0.25-0.0669l0.8174-0.4719v0.9435c0,0.2764,0.2236,0.5,0.5,0.5
	s0.5-0.2236,0.5-0.5v-0.943l0.8164,0.4713c0.0791,0.0454,0.165,0.0669,0.25,0.0669c0.1719,0,0.3408-0.0898,0.4326-0.25
	c0.1387-0.2393,0.0566-0.5449-0.1826-0.6831l-0.8167-0.4714l0.8167-0.4714C14.0561,19.5219,14.1382,19.2163,13.9995,18.977z"/>
</svg>

    </div>
  );
}
}
export default Snow;